<template>
  <component :is="listType" class="list-decimal pl-5 marker:font-semibold marker:text-los-pink-dark mb-6" :class="[listType === 'ul' ? 'list-disc' : 'list-decimal']">
    <ContentBuilder :content="content.children" />
    <li class="list-item text-base/8 md:text-lg/9" v-for="(item, index) in content.children" :key="index">
      <ContentBuilder :content="item.children" />
    </li>
  </component :is="listType">
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    default: () => {},
  },
});

const listType = computed(() => {
  return props.content.format === 'unordered' ? 'ul' : 'ol';
})
</script>

<style lang="scss" scoped></style>
